import axios from 'axios';
import { decompressData } from '/src/utils/decompressData';

export const fetchAdditionalGeoData = async (property) => {
    console.log('Fetching additional geo data for property:', property);
    const fetchInput = {
        zip: property.zip_code,
        fips: property.fips,
        census_tract: property.census_tract
    }
    console.log('fetchAdditionalGeoData Fetch Input:', fetchInput);
    try {
        const response = await axios.post(
            `${import.meta.env.VITE_API_BASE_URL}/get-geo-data`,
            fetchInput
        );

        console.log('Additional Geo Data Response:', response);
        console.log('Additional Geo Data Response Type:', typeof response);
        console.log('Additional Geo Data Response Data:', response.data);

        if (response.data) {
            
            const output = {}

            if (response.data.census_tract.success) {
                output.census_tract_geometry = response.data.census_tract.data;
            }

            if (response.data.housing_market_data_fips.success) {
                output.housing_market_data_fips = response.data.housing_market_data_fips.data;
            }

            if (response.data.housing_market_data_zip.success) {
                output.housing_market_data_zip = response.data.housing_market_data_zip.data;
            }

            if (response.data.nri.success) {
                output.census_tract_nri = response.data.nri.data;
            }
          
            if (response.data.fema_data.success) {
                output.fema_data = response.data.fema_data.data;
            }
            if (response.data.fema_data_state.success) {
                output.fema_data_state = response.data.fema_data_state.data;
            }
            
            
            console.log('Additional Geo Data Output:', output);
            // Return decompressed data without touching localStorage
            return output;
            return {
                zip: response.data.zip ? {
                    [property.zip_code]: decompressData(response.data.zip)
                } : {},
                fips: response.data.fips ? {
                    [property.fips]: decompressData(response.data.fips)
                } : {},
                state: response.data.state ? {
                    [property.state_short_name]: decompressData(response.data.state)
                } : {}
            };
        }
        return null;
    } catch (error) {
        console.error('Error fetching additional geo data:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        }
        throw error;
    }
};
